const Location = ({ color, width, viewbox }: any) => {
    return (
        <svg width={width} height="45" viewBox={viewbox} version="1.1" 
            xmlns="http://www.w3.org/2000/svg" fill={color} stroke={color} transform="matrix(-1, 0, 0, 1, 0, 0)">
            <g id="SVGRepo_bgCarrier" stroke-width="20"></g>
            <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
            <g id="SVGRepo_iconCarrier"> 
                <title>location</title> 
                <desc>Created with Sketch Beta.</desc> <defs> </defs> 
                <g id="Page-1" stroke-width="0.8" fill="none" fill-rule="evenodd" > 
                    <g id="Icon-Set" transform="translate(-104.000000, -411.000000)" fill={color}> 
                        <path d="M116,426 C114.343,426 113,424.657 113,423 C113,421.343 114.343,420 116,
                        420 C117.657,420 119,421.343 119,423 C119,424.657 117.657,426 116,426 L116,426 Z M116,
                        418 C113.239,418 111,420.238 111,423 C111,425.762 113.239,428 116,428 C118.761,428 121,
                        425.762 121,423 C121,420.238 118.761,418 116,418 L116,418 Z M116,440 C114.337,440.009 106,
                        427.181 106,423 C106,417.478 110.477,413 116,413 C121.523,413 126,417.478 126,423 C126,
                        427.125 117.637,440.009 116,440 L116,440 Z M116,411 C109.373,411 104,416.373 104,423 C104,
                        428.018 114.005,443.011 116,443 C117.964,443.011 128,427.95 128,423 C128,416.373 122.627,
                        411 116,411 L116,411 Z" id="location" > </path> 
                    </g> 
                </g> 
            </g>
        </svg>
    )
}

export default Location